module.exports = __webpack_public_path__ + "img/human_15.88278465.png";